import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef, Children } from 'react';
import { CONTINUOUS_SCROLL_LOAD_STRATEGIES, DEFAULT_ANIMATION_DURATION_SECONDS, DEFAULT_CONTAINER_CLASS_NAME, DEFAULT_INTERSECTION_OBSERVER_ROOT_MARGIN, DEFAULT_INTERSECTION_OBSERVER_THRESHOLD, EAGER_LOAD_STRATEGY, HORIZONTAL_DIRECTION, IN_VIEWPORT_LOAD_STRATEGY, VERTICAL_DIRECTION } from './ContinuousScroll.constants';
import { getInnerContainerStyle } from './ContinuousScroll.utils';
import ContinuousScrollItem from './components/ContinuousScrollItem';
import { classNames } from '../../../../utils/classname';
import useIntersectionObserver from '../../../foundation/hooks/use-intersection-observer/use-intersection-observer';
import { createComponent, isComponentNull } from '../../../foundation/services/components';
import { ChildrenPropType } from '../../../foundation/types/component';
import './ContinuousScroll.less';
var defaultProps = {
  animationDuration: DEFAULT_ANIMATION_DURATION_SECONDS,
  className: '',
  direction: HORIZONTAL_DIRECTION,
  loadStrategy: EAGER_LOAD_STRATEGY
};

// @deprecated. Use ContinuousScrollV2 instead.
export default function ContinuousScroll(_ref) {
  var _classNames;
  var children = _ref.children,
    animationDuration = _ref.animationDuration,
    className = _ref.className,
    direction = _ref.direction,
    loadStrategy = _ref.loadStrategy;
  var containerRef = useRef(null);
  var isInViewport = loadStrategy === IN_VIEWPORT_LOAD_STRATEGY;
  var isEager = loadStrategy === EAGER_LOAD_STRATEGY;
  var _useState = useState(isEager),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useIntersectionObser = useIntersectionObserver(containerRef, {
      defaultActive: isInViewport,
      threshold: DEFAULT_INTERSECTION_OBSERVER_THRESHOLD,
      rootMargin: DEFAULT_INTERSECTION_OBSERVER_ROOT_MARGIN
    }),
    inViewport = _useIntersectionObser.inViewport,
    disconnect = _useIntersectionObser.disconnect;
  useEffect(function () {
    if (inViewport) {
      setShow(true);
      disconnect();
    }
  }, [inViewport]);
  if (isComponentNull(children)) {
    return null;
  }
  var containerClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_CONTAINER_CLASS_NAME, true), _defineProperty(_classNames, className, true), _defineProperty(_classNames, direction, true), _classNames));
  var innerContainerStyle = getInnerContainerStyle({
    animationDuration: animationDuration,
    direction: direction
  });
  var elements = Children.toArray(children);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassName,
    ref: containerRef
  }, show && /*#__PURE__*/React.createElement("div", {
    className: "continuous-scroll-inner-container",
    style: innerContainerStyle
  }, [].concat(_toConsumableArray(elements), _toConsumableArray(elements), _toConsumableArray(elements)).map(function (element, index) {
    return createComponent(element, {
      key: index
    });
  })));
}
ContinuousScroll.Item = ContinuousScrollItem;
ContinuousScroll.defaultProps = defaultProps;